import React, { Suspense, useCallback, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import TopNavigationBar from '../components/layout/TopNavigationBar';
import SidebarNavigation from '../components/layout/SidebarNavigation';
import GlobalModals from '../components/common/GlobalModals';
import { useAuth } from '../contexts/AuthContext';
import { NavigationProvider } from '../contexts/NavigationContext';
import LandingPage from '../pages/LandingPage';
import './MainAppLayout.css';

const MainAppLayout = () => {
  console.log('[MainAppLayout.jsx] RENDERING');
  
  const location = useLocation();
  const isReelsPage = location.pathname === '/reels';
  const { user, currentUser, categories, categoriesLoading, isAdmin, isAuthenticated } = useAuth();
  
  // ✅ DEBUG: Log authentication state
  console.log('🔍 [MainAppLayout] AUTH STATE:', {
    isAuthenticated,
    user: user ? user.username : 'null',
    pathname: location.pathname
  });
  
  const registerPostCreatedCallback = useCallback(() => {}, []);
  
  const contextValue = useMemo(() => ({
    currentUser,
    categories,
    categoriesLoading,
    isAdmin,
    registerPostCreatedCallback,
  }), [currentUser, categories, categoriesLoading, isAdmin, registerPostCreatedCallback]);
  
  const commonModalProps = useMemo(() => ({
    currentUser,
    categories,
    isAdmin,
    onPostCreated: registerPostCreatedCallback,
  }), [currentUser, categories, isAdmin, registerPostCreatedCallback]);
  
  // ✅ If not authenticated, show landing page
  if (!isAuthenticated) {
    console.log('🎯 [MainAppLayout] User not authenticated, showing LandingPage');
    return <LandingPage />;
  }
  
  return (
    <NavigationProvider>
      <div className={`main-app-layout ${isReelsPage ? 'reels-mode' : ''}`}>
        {/* Sidebar Navigation - Hidden on reels page */}
        {!isReelsPage && (
          <div className="sidebar-navigation">
            <SidebarNavigation />
          </div>
        )}
        
        {/* Main Content Wrapper */}
        <div className="content-wrapper">
          {/* Top Navigation Bar - Hidden on reels page */}
          {!isReelsPage && (
            <TopNavigationBar
              user={currentUser}
              isAdmin={isAdmin}
            />
          )}
          
          {/* Page Content */}
          <main className={`main-content ${isReelsPage ? 'full-screen' : ''}`}>
            <Suspense fallback={<div>Loading page...</div>}>
              <Outlet context={contextValue} />
            </Suspense>
          </main>
        </div>
        
        {/* Global Modals */}
        <GlobalModals commonModalProps={commonModalProps} />
      </div>
    </NavigationProvider>
  );
};

export default MainAppLayout;
